import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
export type StatusType = 'ACTIVE' | 'SCHEDULED' | 'EXPIRED';

export interface IStatusTagProps {
  status: StatusType;
  className?: string;
}

const StatusTag: React.FC<IStatusTagProps> = ({ status, className }) => {
  const { t } = useTranslation();
  const getStatusClasses = (status: StatusType) => {
    const statusClasses = {
      ACTIVE: 'text-polar-greens-800',
      SCHEDULED: 'text-secondary-800',
      EXPIRED: 'text-gray-650',
    };

    const dotClasses = {
      ACTIVE: 'bg-polar-greens-800',
      SCHEDULED: 'bg-secondary-800',
      EXPIRED: 'bg-gray-650',
    };

    return {
      text: classNames(statusClasses[status], className),
      dot: dotClasses[status],
    };
  };

  const statusMapper = {
    ACTIVE: t('banner.table.status.active'),
    SCHEDULED: t('banner.table.status.scheduled'),
    EXPIRED: t('banner.table.status.expired'),
    CREATED: t('trip.form.travelersCard.status.CreatedLabel'),
    CANCELLED: t('trip.form.travelersCard.status.CanceledLabel'),
    COMPLETED: t('trip.form.travelersCard.status.CompletedLabel'),
  };

  const classes = getStatusClasses(status);

  return (
    <div className="flex items-center gap-2">
      <div data-testid="status-dot" className={classNames('w-2 h-2 rounded-full', classes.dot)} />
      <span className={classNames(classes.text, 'capitalize')}>{statusMapper[status]}</span>
    </div>
  );
};

export default StatusTag;
